export default "__VITE_ASSET__BPQem7uA__"